import { render, staticRenderFns } from "./manageflourtypes.vue?vue&type=template&id=b3c8042e&scoped=true&"
import script from "./manageflourtypes.vue?vue&type=script&lang=js&"
export * from "./manageflourtypes.vue?vue&type=script&lang=js&"
import style0 from "./manageflourtypes.vue?vue&type=style&index=0&id=b3c8042e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c8042e",
  null
  
)

export default component.exports